import { render, staticRenderFns } from "./InterviewsQuotaExceededCandidate.vue?vue&type=template&id=18f269c8&scoped=true&"
import script from "./InterviewsQuotaExceededCandidate.vue?vue&type=script&lang=js&"
export * from "./InterviewsQuotaExceededCandidate.vue?vue&type=script&lang=js&"
import style0 from "./InterviewsQuotaExceededCandidate.vue?vue&type=style&index=0&id=18f269c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f269c8",
  null
  
)

/* custom blocks */
import block0 from "./InterviewsQuotaExceededCandidate.vue?vue&type=custom&index=0&blockType=i18n&lang=yml&locale=ru"
if (typeof block0 === 'function') block0(component)
import block1 from "./InterviewsQuotaExceededCandidate.vue?vue&type=custom&index=1&blockType=i18n&lang=yml&locale=en"
if (typeof block1 === 'function') block1(component)

export default component.exports